import { useState, useCallback } from 'react';
import styles from './create-account-card.module.sass';
import { CreateAccountForm } from './create-account-form';
import { ToggleCreateAccountFormBox } from './toggle-create-account-form-box';
import { useEnterpriseDriverCreate } from '../../use-enterprise-driver-create';
import isEmpty from 'lodash/fp/isEmpty';
import analytics from 'service/analytics';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export const CreateAccountCard = ({ refetchEnterpriseDrivers }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberError, setPhoneNumberError] = useState('');
  const { createEnterpriseDriverMutateAsync, createEnterpriseDriverStatus } = useEnterpriseDriverCreate();

  const handleFormOpen = useCallback(() => {
    setIsOpen(true);
    analytics.driverPageCreateDriverAccountButtonClick();
  }, []);

  const handlePhoneNumberChange = useCallback(number => {
    setPhoneNumber(number);
  }, []);

  const reset = useCallback(() => {
    setPhoneNumber('');
    setPhoneNumberError('');
    setIsOpen(false);
  }, []);

  const handleFormSubmit = useCallback(
    async ({ mobile }) => {
      if (isEmpty(mobile)) {
        setPhoneNumberError('此欄位為必填');
        return;
      }

      try {
        await createEnterpriseDriverMutateAsync({ mobile });
        refetchEnterpriseDrivers();
        reset();
      } catch (error) {
        const { message } = error?.response.data.error ?? {};
        if (message == null) return;
        setPhoneNumberError(message);
      }
    },
    [createEnterpriseDriverMutateAsync, reset, refetchEnterpriseDrivers]
  );

  const containerClassName = cx({
    'create-account-card': true,
    mobileEditState: isOpen,
  });

  return (
    <div className={containerClassName}>
      {isOpen ? (
        <CreateAccountForm
          phoneNumber={phoneNumber}
          phoneNumberError={phoneNumberError}
          isLoading={createEnterpriseDriverStatus === 'loading'}
          onClose={reset}
          onPhoneNumberChange={handlePhoneNumberChange}
          onFormSubmit={handleFormSubmit}
        />
      ) : (
        <ToggleCreateAccountFormBox onClick={handleFormOpen} />
      )}
    </div>
  );
};
